import Icon from "./logo";
var CnLayoutColPrototype = {
  title: '列',
  componentName: 'CnLayoutCol',
  // category: '图表',
  icon: Icon,
  docUrl: '',
  isContainer: true,
  // onResizeEnd() {
  //   console.log('onResizeEnd');
  //   enableDivider();
  // },
  configure: [{
    name: 'isCnLayoutCol',
    title: 'CnLayoutCol',
    initialValue: true,
    display: 'none'
  }, {
    name: '_context',
    title: '上下文',
    initialValue: {
      type: 'JSExpression',
      value: 'this'
    },
    display: 'none'
  }]
};
// 原型配置请参考：https://lark.alipay.com/vision/docs/prototype

export { CnLayoutColPrototype };